export const amazonMarketDomains = [
    "amazon.ca",
    "amazon.co.uk",
    "amazon.com.au",
    "amazon.com.mx",
    "amazon.com",
    "amazon.de",
    "amazon.es",
    "amazon.fr",
    "amazon.in",
    "amazon.it",
    "amazon.nl",
    "amazon.co.jp",
    "amazon.com.br",
    "amazon.com.tr",
    "amazon.cn",
    "amazon.sg",
    "amazon.ae",
    "amazon.sa",
    "amazon.se",
    "amazon.pl",
    "amazon.eg",
    "amazon.com.be",
];
export const amazonTLDomains = [
    "ca",
    "co.uk",
    "com.au",
    "com.mx",
    "com",
    "de",
    "es",
    "fr",
    "in",
    "it",
    "nl",
    "co.jp",
    "com.br",
    "com.tr",
    "cn",
    "sg",
    "ae",
    "sa",
    "se",
    "pl",
    "eg",
    "com.be",
];
export const marketplaceTimezones = [
    "Asia/Dubai",
    "Australia/Sydney",
    "Europe/Brussels",
    "America/Sao_Paulo",
    "America/Los_Angeles",
    "Europe/Paris",
    "Africa/Cairo",
    "Asia/Kolkata",
    "Asia/Tokyo",
    "Europe/Amsterdam",
    "Europe/Warsaw",
    "Asia/Riyadh",
    "Europe/Stockholm",
    "Asia/Singapore",
    "Europe/Istanbul",
    "Europe/London",
    "Asia/Shanghai",
];
const timezoneNames = [
    "(GST) Gulf Standard Time - Dubai",
    "(AEST) Australian Eastern Standard Time - Sydney",
    "(CET) Central European Time - Brussels",
    "(BRT) Brasilia Time - Sao Paolo",
    "(PST) Pacific Standard Time - Los Angeles",
    "(CET) Central European Time - Paris",
    "(EET) Eastern European Time - Cairo",
    "(IST) India Standard Time - Kolkata",
    "(JST) Japan Standard Time - Tokyo",
    "(CET) Central European Time - Amsterdam",
    "(CET) Central European Time - Warsaw",
    "AST (Arabia Standard Time) - Riyadh",
    "(CET) Central European Time - Stockholm",
    "(SGT) Singapore Time - Singapore",
    "(TRT) Turkey Time - Istanbul",
    "(GMT) Greenwich Mean Time - London",
    "(CST) China Standard Time - Shanghai",
];
export const timezoneNamesMatch = {
    "Asia/Dubai": "(GST) Gulf Standard Time - Dubai",
    "Australia/Sydney": "(AEST) Australian Eastern Standard Time - Sydney",
    "Europe/Brussels": "(CET) Central European Time - Brussels",
    "America/Sao_Paulo": "(BRT) Brasilia Time - Sao Paolo",
    "America/Los_Angeles": "(PST) Pacific Standard Time - Los Angeles",
    "Europe/Paris": "(CET) Central European Time - Paris",
    "Africa/Cairo": "(EET) Eastern European Time - Cairo",
    "Asia/Kolkata": "(IST) India Standard Time - Kolkata",
    "Asia/Tokyo": "(JST) Japan Standard Time - Tokyo",
    "Europe/Amsterdam": "(CET) Central European Time - Amsterdam",
    "Europe/Warsaw": "(CET) Central European Time - Warsaw",
    "Asia/Riyadh": "AST (Arabia Standard Time) - Riyadh",
    "Europe/Stockholm": "(CET) Central European Time - Stockholm",
    "Asia/Singapore": "(SGT) Singapore Time - Singapore",
    "Europe/Istanbul": "(TRT) Turkey Time - Istanbul",
    "Europe/London": "(GMT) Greenwich Mean Time - London",
    "Asia/Shanghai": "(CST) China Standard Time - Shanghai",
};
export const walmartMarketDomains = ["walmart.com"];
export const walmartMarketTLDomains = ["com"];
export const amazonMarketsData = {
    com: {
        store: "ATVPDKIKX0DER",
        currency: "USD",
        locale: "en-US",
        id: 1,
        domain: "amazon.com",
        TLDomain: "com",
        alias: "US_AMAZON",
        platform: "AMAZON",
        country: "US",
        timezone: "America/Los_Angeles",
    },
    ca: {
        store: "A2EUQ1WTGCTBG2",
        currency: "CAD",
        locale: "en-CA",
        id: 2,
        domain: "amazon.ca",
        TLDomain: "ca",
        alias: "CA_AMAZON",
        platform: "AMAZON",
        country: "CA",
        timezone: "America/Los_Angeles",
    },
    "com.mx": {
        store: "A1AM78C64UM0Y8",
        currency: "MXN",
        locale: "es-MX",
        id: 3,
        domain: "amazon.com.mx",
        TLDomain: "com.mx",
        alias: "MX_AMAZON",
        platform: "AMAZON",
        country: "MX",
        timezone: "America/Los_Angeles",
    },
    de: {
        store: "A1PA6795UKMFR9",
        currency: "EUR",
        locale: "de-DE",
        id: 4,
        domain: "amazon.de",
        TLDomain: "de",
        alias: "DE_AMAZON",
        platform: "AMAZON",
        country: "DE",
        timezone: "Europe/Paris",
    },
    es: {
        store: "A1RKKUPIHCS9HS",
        currency: "EUR",
        locale: "es-ES",
        id: 5,
        domain: "amazon.es",
        TLDomain: "es",
        alias: "ES_AMAZON",
        platform: "AMAZON",
        country: "ES",
        timezone: "Europe/Paris",
    },
    it: {
        store: "APJ6JRA9NG5V4",
        currency: "EUR",
        locale: "it-IT",
        id: 7,
        domain: "amazon.it",
        TLDomain: "it",
        alias: "IT_AMAZON",
        platform: "AMAZON",
        country: "IT",
        timezone: "Europe/Paris",
    },
    fr: {
        store: "A13V1IB3VIYZZH",
        currency: "EUR",
        locale: "fr-FR",
        id: 6,
        domain: "amazon.fr",
        TLDomain: "fr",
        alias: "FR_AMAZON",
        platform: "AMAZON",
        country: "FR",
        timezone: "Europe/Paris",
    },
    "co.uk": {
        store: "A1F83G8C2ARO7P",
        currency: "GBP",
        locale: "en-GB",
        id: 8,
        domain: "amazon.co.uk",
        TLDomain: "co.uk",
        alias: "GB_AMAZON",
        platform: "AMAZON",
        country: "GB",
        timezone: "Europe/London",
    },
    in: {
        store: "A21TJRUUN4KGV",
        currency: "INR",
        locale: "en-IN",
        id: 9,
        domain: "amazon.in",
        TLDomain: "in",
        alias: "IN_AMAZON",
        platform: "AMAZON",
        country: "IN",
        timezone: "Asia/Kolkata",
    },
    nl: {
        store: "A1805IZSGTT6HS",
        currency: "EUR",
        locale: "nl-NL",
        id: 15,
        domain: "amazon.nl",
        TLDomain: "nl",
        alias: "NL_AMAZON",
        platform: "AMAZON",
        country: "NL",
        timezone: "Europe/Amsterdam",
    },
    "com.au": {
        store: "A39IBJ37TRP1C6",
        currency: "AUD",
        locale: "en-AU",
        id: 14,
        domain: "amazon.com.au",
        TLDomain: "com.au",
        alias: "AU_AMAZON",
        platform: "AMAZON",
        country: "AU",
        timezone: "Australia/Sydney",
    },
    "co.jp": {
        store: "A1VC38T7YXB528",
        currency: "JPY",
        locale: "ja-JP",
        id: 10,
        domain: "amazon.co.jp",
        TLDomain: "co.jp",
        alias: "JP_AMAZON",
        platform: "AMAZON",
        country: "JP",
        timezone: "Asia/Tokyo",
    },
    "com.br": {
        store: "A2Q3Y263D00KWC",
        currency: "BRL",
        locale: "pt-BR",
        id: 12,
        domain: "amazon.com.br",
        TLDomain: "com.br",
        alias: "BR_AMAZON",
        platform: "AMAZON",
        country: "BR",
        timezone: "America/Sao_Paulo",
    },
    "com.tr": {
        store: "A33AVAJ2PDY3EV",
        currency: "TRY",
        locale: "tr-TR",
        id: 13,
        domain: "amazon.com.tr",
        TLDomain: "com.tr",
        alias: "TR_AMAZON",
        platform: "AMAZON",
        country: "TR",
        timezone: "Europe/Istanbul",
    },
    cn: {
        store: "AAHKV2X7AFYLW",
        currency: "CNY",
        locale: "zh-CN",
        id: 11,
        domain: "amazon.cn",
        TLDomain: "cn",
        alias: "CN_AMAZON",
        platform: "AMAZON",
        country: "CN",
        timezone: "Asia/Shanghai",
    },
    sg: {
        store: "A19VAU5U5O7RUS",
        currency: "SGD",
        locale: "en_SG",
        id: 16,
        domain: "amazon.sg",
        TLDomain: "sg",
        alias: "SG_AMAZON",
        platform: "AMAZON",
        country: "SG",
        timezone: "Asia/Singapore",
    },
    ae: {
        store: "A2VIGQ35RCS4UG",
        currency: "AED",
        locale: "ar-AE",
        id: 17,
        domain: "amazon.ae",
        TLDomain: "ae",
        alias: "AE_AMAZON",
        platform: "AMAZON",
        country: "AE",
        timezone: "Asia/Dubai",
    },
    sa: {
        store: "A17E79C6D8DWNP",
        currency: "SAR",
        locale: "ar-SA",
        id: 19,
        domain: "amazon.sa",
        TLDomain: "sa",
        alias: "SA_AMAZON",
        platform: "AMAZON",
        country: "SA",
        timezone: "Asia/Riyadh",
    },
    se: {
        store: "A2NODRKZP88ZB9",
        currency: "SEK",
        locale: "sv-SE",
        id: 20,
        domain: "amazon.se",
        TLDomain: "se",
        alias: "SE_AMAZON",
        platform: "AMAZON",
        country: "SE",
        timezone: "Europe/Stockholm",
    },
    pl: {
        store: "A1C3SOZRARQ6R3",
        currency: "PLN",
        locale: "pl-PL",
        id: 21,
        domain: "amazon.pl",
        TLDomain: "pl",
        alias: "PL_AMAZON",
        platform: "AMAZON",
        country: "PL",
        timezone: "Europe/Warsaw",
    },
    eg: {
        store: "ARBP9OOSHTCHU",
        currency: "EGP",
        locale: "ar-EG",
        id: 18,
        domain: "amazon.eg",
        TLDomain: "eg",
        alias: "EG_AMAZON",
        platform: "AMAZON",
        country: "EG",
        timezone: "Africa/Cairo",
    },
    "com.be": {
        store: "AMEN7PMS3EDWL",
        currency: "EUR",
        locale: "nl-BE",
        id: 22,
        domain: "amazon.com.be",
        TLDomain: "com.be",
        alias: "BE_AMAZON",
        platform: "AMAZON",
        country: "BE",
        timezone: "Europe/Brussels",
    },
};
export const walmartMarketsData = {
    com: {
        store: "WALMART_US",
        currency: "USD",
        locale: "en-US",
        id: 101,
        domain: "walmart.com",
        TLDomain: "com",
        alias: "WALMART_US",
        platform: "WALMART",
        country: "US",
        timezone: "America/Los_Angeles",
    },
};
const platformMap = {
    AM: amazonMarketsData,
    AMAZON: amazonMarketsData,
    WM: walmartMarketsData,
    WALMART: walmartMarketsData,
};
/**
 * The function for getting marketplace property
 *
 * You can get following properties:
 *
 * .store, .currency, .locale, .id, .domain, .TLDomain, .alias, .country
 *  @example
 *  getMarketInfo("AM", "domain", "amazon.ae").store // return A2VIGQ35RCS4UG
 *  getMarketInfo("AM", "domain", "amazon.ae").id // return 17
 *  getMarketInfo("AM", "domain", "amazon.ae").TLDomain // return ae
 *  getMarketInfo("AM", "domain", "amazon.ae").locale // return ar-AE
 *  getMarketInfo("AM", "domain", "amazon.ae").currency // return AED
 *  getMarketInfo("AM", "domain", "amazon.ae").domain // return amazon.ae
 *  getMarketInfo("AM", "domain", "amazon.ae").country // return AE
 *
 * @param  {string} platform "AM" | "WM" | "AMAZON" | "WALMART"
 * @param  {string} searchType "store" | "domain" | "TLDomain" | "id" | "country"
 * @param  {string} arg value for search
 * */
export const getMarketInfo = (platform, searchType, arg) => {
    return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.values(platformMap[platform]).find((m) => m[searchType] === arg) ||
        (platform === "AM" || platform === "AMAZON"
            ? amazonMarketsData["com"]
            : walmartMarketsData["com"]));
};
/**
 * The function for getting marketplace property.
 *
 * You can get following properties:
 *
 * .store, .currency, .locale, .id, .domain, .TLDomain, .alias, .country
 *
 * @param  {string} searchType "store" | "domain" | "id"
 * @param  {string} value value for search
 *
 * @example
 * getMarketData("store", "ATVPDKIKX0DER").domain // return: amazon.com
 * getMarketData("store", "A2EUQ1WTGCTBG2").domain // return: amazon.ca
 *
 * getMarketData("domain", "amazon.com").store // return: ATVPDKIKX0DER
 * getMarketData("domain", "amazon.ca").store // return: A2EUQ1WTGCTBG2
 * getMarketData("domain", "amazon.com").id // return: 1
 * getMarketData("domain", "amazon.com").currency // return: USD
 *
 */
export const getMarketData = (searchType, value) => {
    if (searchType === "id") {
        return value === 101
            ? getMarketInfo("WALMART", "id", value)
            : getMarketInfo("AMAZON", "id", value);
    }
    else {
        return getMarketInfo(value.includes(searchType === "store" ? "WALMART" : "walmart") ? "WM" : "AM", searchType, 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        value);
    }
};
